import { MoreVert } from '@mui/icons-material'
import { IconButton, Menu } from '@mui/material'
import { Row } from '@tanstack/react-table'

import { BuildOrderForTable } from 'features/history/pages/BuildsPage/hooks/useGetBuildOrders'
import { useMenu } from 'hooks/useMenu'
import { DownloadItem } from './components/DownloadItem'

export const ActionsCell = ({
  configurationUrl,
  id,
}: Row<BuildOrderForTable>['original']): React.JSX.Element => {
  const { anchor, close, isOpen, open } = useMenu()

  if (!configurationUrl) {
    return <></>
  }

  return (
    <>
      <IconButton onClick={open}>
        <MoreVert data-cy='more-vert-icon' />
      </IconButton>

      <Menu
        anchorEl={anchor}
        onClose={close}
        open={isOpen}
      >
        <DownloadItem {...{ configurationUrl, id, onDownloadEnd: close }} />
      </Menu>
    </>
  )
}
